var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Stock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Rayonnage isometrique de volumes.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 173.1 L 444.6 285.3 L 261.7 390.9 L 67.4 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 230.3,
    y1: 207.8,
    x2: 127.4,
    y2: 267.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 268.9,
    y1: 230,
    x2: 166,
    y2: 289.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 307.4,
    y1: 252.3,
    x2: 204.6,
    y2: 311.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 346,
    y1: 274.6,
    x2: 243.1,
    y2: 334
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 384.6,
    y1: 296.9,
    x2: 281.7,
    y2: 356.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 230.3,
    y1: 207.8,
    x2: 384.6,
    y2: 296.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 196,
    y1: 227.6,
    x2: 350.3,
    y2: 316.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 161.7,
    y1: 247.3,
    x2: 316,
    y2: 336.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 127.4,
    y1: 267.1,
    x2: 281.7,
    y2: 356.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 211.7 221.8 L 360.3 307.6 L 300.3 342.2 L 151.7 256.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 211.7 221.8 L 360.3 307.6 L 300.3 342.2 L 151.7 256.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 243.1 215.8 L 206 237.3 L 206 273.6 L 243.1 252.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 171.7 217.5 L 206 237.3 L 206 273.6 L 171.7 253.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 208.8 196 L 243.1 215.8 L 206 237.3 L 171.7 217.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 208.8 196 L 243.1 215.8 L 206 237.3 L 171.7 217.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 243.1,
    y1: 215.8,
    x2: 243.1,
    y2: 252.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 206,
    y1: 237.3,
    x2: 206,
    y2: 273.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 171.7,
    y1: 217.5,
    x2: 171.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 243.1,
    y1: 252.1,
    x2: 206,
    y2: 273.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 206,
    y1: 273.6,
    x2: 171.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 292.3 244.2 L 255.1 265.7 L 255.1 302 L 292.3 280.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 220.8 245.9 L 255.1 265.7 L 255.1 302 L 220.8 282.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 258 224.4 L 292.3 244.2 L 255.1 265.7 L 220.8 245.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 258 224.4 L 292.3 244.2 L 255.1 265.7 L 220.8 245.9 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 292.3,
    y1: 244.2,
    x2: 292.3,
    y2: 280.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 255.1,
    y1: 265.7,
    x2: 255.1,
    y2: 302
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 220.8,
    y1: 245.9,
    x2: 220.8,
    y2: 282.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 292.3,
    y1: 280.5,
    x2: 255.1,
    y2: 302
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 255.1,
    y1: 302,
    x2: 220.8,
    y2: 282.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 341.5 272.6 L 304.3 294 L 304.3 330.3 L 341.5 308.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 270 274.2 L 304.3 294 L 304.3 330.3 L 270 310.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 307.2 252.8 L 341.5 272.6 L 304.3 294 L 270 274.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 307.2 252.8 L 341.5 272.6 L 304.3 294 L 270 274.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 341.5,
    y1: 272.6,
    x2: 341.5,
    y2: 308.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 304.3,
    y1: 294,
    x2: 304.3,
    y2: 330.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 270,
    y1: 274.2,
    x2: 270,
    y2: 310.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 341.5,
    y1: 308.9,
    x2: 304.3,
    y2: 330.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 304.3,
    y1: 330.3,
    x2: 270,
    y2: 310.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 211.7 169 L 360.3 254.8 L 300.3 289.4 L 151.7 203.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 211.7 169 L 360.3 254.8 L 300.3 289.4 L 151.7 203.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 243.1 163 L 206 184.5 L 206 220.8 L 243.1 199.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 171.7 164.7 L 206 184.5 L 206 220.8 L 171.7 201 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 208.8 143.2 L 243.1 163 L 206 184.5 L 171.7 164.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 208.8 143.2 L 243.1 163 L 206 184.5 L 171.7 164.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 243.1,
    y1: 163,
    x2: 243.1,
    y2: 199.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 206,
    y1: 184.5,
    x2: 206,
    y2: 220.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 171.7,
    y1: 164.7,
    x2: 171.7,
    y2: 201
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 243.1,
    y1: 199.3,
    x2: 206,
    y2: 220.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 206,
    y1: 220.8,
    x2: 171.7,
    y2: 201
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 341.5 219.8 L 304.3 241.2 L 304.3 277.5 L 341.5 256.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 270 221.4 L 304.3 241.2 L 304.3 277.5 L 270 257.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 307.2 200 L 341.5 219.8 L 304.3 241.2 L 270 221.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 307.2 200 L 341.5 219.8 L 304.3 241.2 L 270 221.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 341.5,
    y1: 219.8,
    x2: 341.5,
    y2: 256.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 304.3,
    y1: 241.2,
    x2: 304.3,
    y2: 277.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 270,
    y1: 221.4,
    x2: 270,
    y2: 257.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 341.5,
    y1: 256.1,
    x2: 304.3,
    y2: 277.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 304.3,
    y1: 277.5,
    x2: 270,
    y2: 257.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d3",
    cx: 284.6,
    cy: 249,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 284.6,
    cy: 249,
    r: 3.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.8e7468efd8298912c33099c3752c22b5.svg";
export { ForwardRef as ReactComponent };